import { useId } from 'react'

import './base.css'

/** Причина административной команды: обязательна, до 2000 символов (договор C3a). */
export const MAX_REASON_LENGTH = 2000

export function ReasonField({
  label,
  value,
  onChange,
}: {
  label: string
  value: string
  onChange: (value: string) => void
}) {
  const id = useId()
  return (
    <div className="sale-textarea">
      <label className="krp-field__label" htmlFor={id}>
        {label}
      </label>
      <textarea
        id={id}
        value={value}
        maxLength={MAX_REASON_LENGTH}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
